<template>
    <div>
        <CommonHeader/>
        <div style="background: #6A9FF9;padding: 20px 0;height: 300px">
            <div class="container">
                <a-row type="flex" justify="space-around" align="middle">
                    <a-col :span="10">
                        <h1 class="color-white" style="font-size: 40px">帮助中心</h1>
<!--                        <a-input-search placeholder="搜索常见帮助问题" size="large">-->
<!--                            <a-button slot="enterButton">-->
<!--                                <a-icon type="search" />-->
<!--                            </a-button>-->
<!--                        </a-input-search>-->
                    </a-col>
                    <a-col :span="14">
                        <img style="margin-left: auto" src="../../img/p2.png">
                    </a-col>
                </a-row>
            </div>
        </div>
        <div class="container" style="margin-top: -20px;box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px;min-height: calc(100vh - 56px - 88px - 280px);background: #fff">
            <div class="bg-white">
                <a-row>
                    <a-col :span="24">
                        <a-card>
                            <h2>账号管理</h2>
                            <div class="division"></div>
                            <ul class="t1">
                                <li><a href="javascript:;" @click="findPass1"><img src="../../img/help/icon5.png" >注册账号</a></li>
                                <li><a href="javascript:;" @click="findPass2"><img src="../../img/help/icon1.png">如何登陆</a></li>
                                <li><a href="javascript:;" @click="findPass3"><img src="../../img/help/icon11.png">单位认证/变更</a></li>
                                <li><a href="javascript:;" @click="findPass4"><img src="../../img/help/icon13.png">绑定/解绑单位</a></li>
                                <li><a href="javascript:;" @click="findPass5"><img src="../../img/help/icon17.png">子账号管理</a></li>
                            </ul>
                            <h2 class="mt-5">项目相关问题</h2>
                            <div class="division"></div>
                            <ul class="t1">
                                <li><a href="javascript:;" @click="findPass6"><img src="../../img/help/icon15.png" >项目报名</a></li>
                                <li><a href="javascript:;" @click="findPass7"><img src="../../img/help/icon14.png">项目信息</a></li>
                                <li><a href="javascript:;" @click="findPass8"><img src="../../img/help/icon8.png">投标保证金</a></li>
                                <li><a href="javascript:;" @click="findPass9"><img src="../../img/help/icon6.png">项目答疑</a></li>
                                <li><a href="javascript:;" @click="findPass10"><img src="../../img/help/icon4.png">项目竞价</a></li>
                                <li><a href="javascript:;" @click="findPass11"><img src="../../img/help/icon6.png">项目结果</a></li>
                                <li><a href="javascript:;" @click="findPass12"><img src="../../img/help/icon3.png">成交通知书</a></li>
                                <li><a href="javascript:;" @click="findPass13"><img src="../../img/help/icon16.png">合同备案</a></li>
                            </ul>
<!--                            <h2 class="mt-5">仍需要其他帮助？</h2>-->
<!--                            <div class="division"></div>-->
<!--                            <ul class="t2">-->
<!--                                <li>电话：020-58797485</li>-->
<!--                            </ul>-->
                        </a-card>
                    </a-col>
                </a-row>
            </div>
        </div>
        <CommonFooter/>
    </div>
</template>

<script>
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    export default {
        components: {
            CommonHeader,
            CommonFooter,
        },
        data () {
            return {

            }
        },
        methods: {
          findPass1() {
            this.$router.push({path:"/message/SysHelpIndex?id=1"})
          },
          findPass2() {
            this.$router.push({path:"/message/SysHelpIndex?id=2"})
          },
          findPass3() {
            this.$router.push({path:"/message/SysHelpIndex?id=3"})
          },
          findPass4() {
            this.$router.push({path:"/message/SysHelpIndex?id=4"})
          },
          findPass5() {
            this.$router.push({path:"/message/SysHelpIndex?id=5"})
          },
          findPass6() {
            this.$router.push({path:"/message/SysHelpIndex2?id=1"})
          },
          findPass7() {
            this.$router.push({path:"/message/SysHelpIndex2?id=2"})
          },
          findPass8() {
            this.$router.push({path:"/message/SysHelpIndex2?id=3"})
          },
          findPass9() {
            this.$router.push({path:"/message/SysHelpIndex2?id=4"})
          },
          findPass10() {
            this.$router.push({path:"/message/SysHelpIndex2?id=5"})
          },
          findPass11() {
            this.$router.push({path:"/message/SysHelpIndex2?id=6"})
          },
          findPass12() {
            this.$router.push({path:"/message/SysHelpIndex2?id=7"})
          },
          findPass13() {
            this.$router.push({path:"/message/SysHelpIndex2?id=8"})
          }
        }
    }
</script>

<style scoped>
    .t1{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t1 li{
        width: 25%;
        display: inline-block;
        margin: 15px 0;
    }
    .t1 li a{
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #262626;
    }
    .t1 li a:hover{
        color: #2f7fe3;
    }
    .t1 li a img{
        margin-right: 8px;
    }

    .t2{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t2 li{
        width: 23%;
        display: inline-block;
        background: #f7f7f7;
        font-size: 16px;
        padding: 12px;
        color: #000;
        margin-left: 2.66666666%;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .t2 li:nth-child(4n-3){
        margin-left: 0;
    }
    .ant-card-bordered{
        border: none;
    }
</style>
